import { useCallback, useEffect } from 'react'

export function useCommand(func, commands = ['ctrl', 'shift', 'l']) {
  const handleFunc = useCallback(
    (e) => {
      //? Cria os comandos F do teclado
      const commandsF = []

      for (let c = 1; c <= 12; c++) {
        commandsF.push(`F${c}`)
      }

      //? Percorre cada comando e atribui a ele um novo valor
      const allCommandsWerePressed = commands.every((command) =>
        command === 'ctrl'
          ? e.ctrlKey
          : command === 'shift'
            ? e.shiftKey
            : command === 'alt'
              ? e.altKey
              : commandsF.includes(e.key)
                ? e.key === command.toUpperCase()
                : e.key.toLowerCase() === command.toLowerCase(),
      )

      //? Se todos eles forem pressionados, previne quaisquer comportamento padrão no navegador, e executa a função
      if (allCommandsWerePressed) {
        e.preventDefault()
        func()
      }
    },
    [commands, func],
  )

  useEffect(() => {
    document.body.addEventListener('keydown', handleFunc)

    return () => {
      document.body.removeEventListener('keydown', handleFunc)
    }
  }, [handleFunc])
}
